import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { APP_INITIALIZER, inject, InjectionToken, makeStateKey, Optional, PLATFORM_ID, Provider, TransferState } from '@angular/core';
import { ChannelTokenService } from './core/providers/channel-token/channel-token.service';
import { CHANNEL_TOKEN, SSR_CHANNEL_TOKEN_KEY } from './core/providers/channel-token/channel-token.token';

export function seedChannelToken(
    platformId: object,
    transfer: TransferState,
    channelToken: string | null,
    channelTokenService: ChannelTokenService,
): () => void {
    return () => {
        if (isPlatformServer(platformId) && channelToken) {
            transfer.set(SSR_CHANNEL_TOKEN_KEY, channelToken);
        }
        channelTokenService.init(channelToken);
    };
}

export const CHANNEL_TOKEN_INITIALIZER: Provider = {
  provide : APP_INITIALIZER,
  useFactory: seedChannelToken,
  deps   : [
    PLATFORM_ID,
    TransferState,
    [new Optional(), CHANNEL_TOKEN],
    ChannelTokenService,
  ],
  multi  : true,
};